var path = '/var/www/mmscny-website/src/app/common/components/reference-maps-switch-tab/reference-maps-switch-tab.html';
var html = "<div class=\"text-center other-maps-switch\"> <h3 class=text-capitalize>other reference maps</h3> <div class=other-maps> <div class=map-data ng-repeat=\"map in $ctrl.data.referenceMaps\" ui-sref={{map.name}}> <h4 class=\"text-capitalize text-left notranslate\">{{map.displayName}}</h4> <span> <img src=/./images/green-arrow-right.png class=img-responsive /> </span> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/reference-maps-switch-tab/reference-maps-switch-tab.html
// module id = 658
// module chunks = 0